export default "__VITE_ASSET__D79wnksY__"